module.exports = __webpack_public_path__ + "img/dollar-full.a633dfec.svg";